import { axios } from 'shared/services/axios'

export function fetchAccessAuthorization(authId) {
  return axios.get(`/authorization/v1/access_authorizations/${authId}`)
    .then(response => response.data)
}

export function fetchCampaign(authId) {
  return axios.get(`/authorization/v1/access_authorizations/${authId}/campaign`)
    .then(response => response.data)
}

export function fetchLocale(authId) {
  return axios.get(`/authorization/v1/access_authorizations/${authId}/locale`)
    .then(response => response.data)
}
